import { render, staticRenderFns } from "./outside.vue?vue&type=template&id=ebf10b7e&scoped=true"
import script from "./outside.vue?vue&type=script&lang=js"
export * from "./outside.vue?vue&type=script&lang=js"
import style0 from "./outside.vue?vue&type=style&index=0&id=ebf10b7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf10b7e",
  null
  
)

export default component.exports